import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit, ViewRef, ChangeDetectionStrategy } from '@angular/core';
import {restore} from "../../assets/json/restoreTooltip.en";
import {FieldType} from "@ngx-formly/core";
import { Subject, takeUntil } from "rxjs";
import {AppStateService} from "src/app/core-module/services/app-state.service";
import { AloAocStateService } from "../core-module/services/state/alo-aoc-state.service";
import { FeatureDataStateService } from "../core-module/services/state/feature-data-state.service";
import { FeatureDefaultsStateService } from "../core-module/services/state/feature-defaults-state.service";
const USER_SPECIFIED = "User specified";
@Component({
  standalone: false,
  selector: "app-ztvoutput",
  templateUrl: "./ztvoutput.component.html",
  styleUrls: ["./ztvoutput.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ZtvoutputComponent extends FieldType implements OnInit, OnDestroy {
  @Input() field;
  formatVersion: LegacyAny;
  column: LegacyAny;
  properties: LegacyAny = [];
  defaultColor: boolean = true;
  inputError: LegacyAny = [];
  CurveSelection: LegacyAny;
  ngModelval: LegacyAny = {};
  restoreText = restore;
  userSpecified: boolean = false;
  curveSurveyValues = {};
  dimLevelColumn = [];
  outputVoltageColumn = [];
  quickConfigvalue;
  quickConfigCustomCSS;
  setQuickConfig;
  fileResponse: LegacyAny;
  isEdited: LegacyAny;
  ztvoutputDefaultColor;
  ztvoutputCreateFile: boolean;
  curve: string;
  private readonly destroy$ = new Subject<void>();
  constructor(
    private ref: ChangeDetectorRef, private appState: AppStateService,
    private featureData: FeatureDataStateService,
    private featureDefaults: FeatureDefaultsStateService,
    private aloAoc: AloAocStateService
  ) {
    super();
  }
  resetDefaultztvoutputValues() {
    this.ngModelval["CurveSelection"] = this.CurveSelection.default;
    this.userSpecified = this.ngModelval["CurveSelection"] === USER_SPECIFIED;
    const dimLevelData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("DimLevel");
      });
    const outputVoltageData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("OutputVoltage");
      });
    this.dimLevelColumn = dimLevelData;
    this.outputVoltageColumn = outputVoltageData;
    for (let index = 0; index < dimLevelData.length; index++) {
      const element = dimLevelData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
    for (let index = 0; index < outputVoltageData.length; index++) {
      const element = outputVoltageData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
    for (const type in this.inputError) {
      this.inputError[type] = false;
    }
    this.ztvoutputCreateFile = false;
    this.featureData.ztvoutputInputError(this.ztvoutputCreateFile);
    this.sendztvoutputdata(this.ngModelval);
    this.ref.detectChanges();
  }
    checkInvalidValues(): void {
    const activeFields = [
      'CurveSelection',
      ...(this.userSpecified
        ? [...this.dimLevelColumn, ...this.outputVoltageColumn]
        : [])
    ];

  this.ztvoutputCreateFile = activeFields.some(
    field => this.inputError[field] === true
  );

  this.featureData.ztvoutputInputError(this.ztvoutputCreateFile);
}
  ngOnInit() {
    this.isEdited = false;
    this.featureDefaults.getztvoutputDefaultValue.pipe(takeUntil(this.destroy$)).subscribe((response) => {
      if (response == "valid") {
        this.ztvoutputDefaultColor = true;
        this.resetDefaultztvoutputValues();
      }
    });
    this.featureData.getztvoutputData.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data) {
        this.ngModelval = data;
        this.userSpecified = this.ngModelval["CurveSelection"] === USER_SPECIFIED;
        this.checkdfault();
        this.checkInvalidValues();
      }
    });
    this.formatVersion = this.field.featureVersion;
    this.column = this.field.requiredProperties;
    this.properties = this.field.properties;
    this.featureData.ztvoutputInputError(false);
    //curve slection
    if (this.properties.CurveSelection) {
      let CurveSelectionEnum = [];
      CurveSelectionEnum = this.properties.CurveSelection.enum;
      const enumCurveValues = {};
      const enumKeys = [];
      CurveSelectionEnum.forEach((item, i) => {
        enumCurveValues[item] = CurveSelectionEnum[i];
        enumKeys.push(item);
        this.curveSurveyValues = enumCurveValues;
      });
      this.properties.CurveSelection["enum"] = enumKeys;
      this.CurveSelection = this.properties.CurveSelection;
      this.ngModelval["CurveSelection"] = this.CurveSelection.default;
      this.userSpecified = this.ngModelval["CurveSelection"] === USER_SPECIFIED;
    }
    const dimLevelData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("DimLevel");
      });
    const outputVoltageData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("OutputVoltage");
      });
    this.dimLevelColumn = dimLevelData;
    this.outputVoltageColumn = outputVoltageData;
    for (let index = 0; index < dimLevelData.length; index++) {
      const element = dimLevelData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
    for (let index = 0; index < outputVoltageData.length; index++) {
      const element = outputVoltageData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
    const aaa = this.appState.getSaveSetData();
    const unSelectedFeat = this.appState.getUnSelectedFeatConfig();
    let isConfigEdited = false;
    let featIndex: number = 0;
    if (unSelectedFeat != null && Array.isArray(unSelectedFeat)) {
      unSelectedFeat.forEach((element) => {
        if (element["featureName"].toString().toUpperCase() === "ZTVOUTPUT") {
          isConfigEdited = true;
          this.fileResponse = {};
          const ztvOutputUnSelectedVal: LegacyAny = element["featureParameters"][0];
          // let ztvEditedData = {
          //   resp: {
          //     Ztv: ztvUnSelectedVal,
          //   },
          // };
          // this.fileResponse = ztvEditedData;
          this.addztvoutputLoadedFeatureReadValues(ztvOutputUnSelectedVal);
          unSelectedFeat.splice(featIndex, 1);
          this.appState.setUnSelectedFeatConfig(
            unSelectedFeat);
        } else {
          featIndex++;
        }
      });
    }

    if (!isConfigEdited) {
      // Use centralized method to get feature data
      // This automatically prioritizes SaveSetData over ConfigurationData
      const ztvOutputData = this.appState.getFeatureData('ZtvOutput');
      if (ztvOutputData) {
        this.addztvoutputLoadedFeatureReadValues(ztvOutputData);
      }
    }

    this.aloAoc.getquickConfig.pipe(takeUntil(this.destroy$)).subscribe((data) => {
      if (data === "quickConfig") {
        this.quickConfigvalue = true;
        this.quickConfigCustomCSS = "quick-custom-inputbox";
        this.setQuickConfig = "quickConfig";
      } else {
        this.quickConfigvalue = false;
        this.quickConfigCustomCSS = "custom-inputbox";
        this.setQuickConfig = "standard";
      }
      setTimeout(() => {
        if (this.ref && !(this.ref as ViewRef).destroyed) {
          this.ref.detectChanges();
        }
      });
    });
    this.sendztvoutputdata(this.ngModelval);
    this.isEdited = true;
  }

  ztvUserSpecified() {
    const dimLevelData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("DimLevel");
      });
    const outputVoltageData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("OutputVoltage");
      });
    this.dimLevelColumn = dimLevelData;
    this.outputVoltageColumn = outputVoltageData;
    for (let index = 0; index < dimLevelData.length; index++) {
      const element = dimLevelData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
    for (let index = 0; index < outputVoltageData.length; index++) {
      const element = outputVoltageData[index];
      this.ngModelval[element] = this.properties[element]["default"];
    }
  }
  addztvoutputLoadedFeatureReadValues(ztvoutput: LegacyAny) {
    const ztvoutputObj = ztvoutput;
    const keys = Object.keys(ztvoutputObj);
    const values = Object.values(ztvoutputObj);
    // Populate ngModelval with actual stored values before validation so that
    // ordering checks in textValChanged compare real values, not defaults.
    const result = [];
    keys.forEach((key, i) => (result[key] = values[i]));
    this.ngModelval = result;
    this.ngModelval["CurveSelection"] = result["CurveSelection"];
    keys.forEach((key, i) => {
      this.textValChanged(values[i], key);
    });
    const dimLevelData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("DimLevel");
      });
    const outputVoltageData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("OutputVoltage");
      });
    this.dimLevelColumn = dimLevelData;
    this.outputVoltageColumn = outputVoltageData;
    this.userSpecified = this.ngModelval["CurveSelection"] === USER_SPECIFIED;
    for (let index = 0; index < dimLevelData.length; index++) {
      const element = dimLevelData[index];
      this.ngModelval[element] = result[element];
    }
    for (let index = 0; index < outputVoltageData.length; index++) {
      const element = outputVoltageData[index];
      this.ngModelval[element] = result[element];
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.sendztvoutputdata(this.ngModelval);
    this.ref.detectChanges();
  }
  setConfigurationData(value, keyVal) {
    if (value != null) {
      // Use centralized method to save feature data
      // This automatically saves to both ConfigurationData and SaveSetData
      const ztvoutputObj = Object.assign({}, value);
      this.appState.setFeatureData(keyVal, ztvoutputObj);
    }
  }
  sendztvoutputdata(val) {
    this.featureData.sendztvoutputdata(val);
    if (this.isEdited) {
      this.setConfigurationData(this.ngModelval, "ZtvOutput");
    }
  }
  textValChanged(value, itemKey) {
    const dimLevelData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("DimLevel");
      });
    const outputVoltageData =
      this.field.allOf[0].then.dependencies.CurveSelection.filter(function (
        item
      ) {
        return item.startsWith("OutputVoltage");
      });
    if (dimLevelData.indexOf(itemKey) !== -1) {
      const index = dimLevelData.indexOf(itemKey);
      const prevElement = dimLevelData[index - 1];
      const element = dimLevelData[index];
      const nextElement = dimLevelData[index + 1];
      if (
        (nextElement != null &&
          Number(this.ngModelval[element]) >=
            Number(this.ngModelval[nextElement])) ||
        (prevElement != null &&
          Number(this.ngModelval[element]) <=
            Number(this.ngModelval[prevElement]))
      ) {
        this.inputError[element] = true;
      } else {
        const itemKeyMin = this.properties[element]["minimum"];
        const itemKeyMax = this.properties[element]["maximum"];
        if (
          Number(value) < Number(itemKeyMin) ||
          Number(value) > Number(itemKeyMax)
        ) {
          this.inputError[element] = true;
          this.ngModelval[element] = Number(value);
        } else if (
          this.ngModelval[element] === "" ||
          isNaN(this.ngModelval[element])
        ) {
          this.inputError[element] = true;
        } else {
          this.inputError[element] = false;
          this.ngModelval[element] = Number(this.ngModelval[element]);
        }
      }
    } else if (outputVoltageData.indexOf(itemKey) !== -1) {
      const indexOutputVoltage = outputVoltageData.indexOf(itemKey);
      const elementOutputVoltage = outputVoltageData[indexOutputVoltage];
      if (this.ngModelval[elementOutputVoltage] === "") {
        this.inputError[elementOutputVoltage] = true;
      }
      const prevElement = outputVoltageData[indexOutputVoltage - 1];
      const nextElementOutputVoltage =
        outputVoltageData[indexOutputVoltage + 1];
      if (
        (nextElementOutputVoltage != null &&
          Number(this.ngModelval[elementOutputVoltage]) >=
            Number(this.ngModelval[nextElementOutputVoltage])) ||
        (prevElement != null &&
          Number(this.ngModelval[elementOutputVoltage]) <=
            Number(this.ngModelval[prevElement]))
      ) {
        this.inputError[elementOutputVoltage] = true;
      } else {
        const itemKeyMin = this.properties[itemKey]["minimum"];
        const itemKeyMax = this.properties[itemKey]["maximum"];
        if (
          Number(value) < Number(itemKeyMin) ||
          Number(value) > Number(itemKeyMax)
        ) {
          this.inputError[itemKey] = true;
          this.ngModelval[itemKey] = parseFloat(value);
        } else if (
          this.ngModelval[elementOutputVoltage] === "" ||
          isNaN(this.ngModelval[elementOutputVoltage])
        ) {
          this.inputError[elementOutputVoltage] = true;
        } else {
          this.inputError[elementOutputVoltage] = false;
          this.ngModelval[itemKey] = parseFloat(this.ngModelval[itemKey]);
        }
      }
    }
    this.checkdfault();
    this.checkInvalidValues();
    this.featureData.ztvoutputEditedVal(this.ztvoutputDefaultColor);
    this.sendztvoutputdata(this.ngModelval);
  }
  checkdfault() {
    this.properties = this.field.properties;

    const activeFields = [
      "CurveSelection",
      ...(this.userSpecified
        ? [...this.dimLevelColumn, ...this.outputVoltageColumn]
        : [])
    ];

    this.ztvoutputDefaultColor = activeFields.every(key =>
      key === "CurveSelection"
        ? this.ngModelval[key] === this.properties[key]["default"]
        : Number(this.ngModelval[key]) === Number(this.properties[key]["default"])
    );

    this.featureData.ztvoutputEditedVal(this.ztvoutputDefaultColor);
  }

  ZtvoutputvalueChange(modelValue) {
    this.ngModelval["CurveSelection"] = modelValue;
    this.userSpecified = modelValue === USER_SPECIFIED;

    this.checkdfault();
    this.checkInvalidValues();
    this.sendztvoutputdata(this.ngModelval);
  }
  numberOnlyAlongWithDec(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode != 46 && charCode > 31 && (charCode < 48 || charCode > 57));
  }
  numberOnly(event): boolean {
    const charCode = event.which ? event.which : event.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }
  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
